module.exports = __webpack_public_path__ + "static/ocean-robbins.33d8da96.jpg";